// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Percent20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Percent20: FC<Percent20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M6.496 9c-.692 0-1.28-.244-1.767-.733A2.42 2.42 0 0 1 4 6.496c0-.692.244-1.28.733-1.767A2.42 2.42 0 0 1 6.504 4c.692 0 1.28.244 1.767.733.486.49.729 1.08.729 1.771 0 .692-.244 1.28-.733 1.767A2.42 2.42 0 0 1 6.496 9ZM6.5 7.5a.964.964 0 0 0 .708-.292A.964.964 0 0 0 7.5 6.5a.964.964 0 0 0-.292-.708A.964.964 0 0 0 6.5 5.5a.964.964 0 0 0-.708.292.964.964 0 0 0-.292.708c0 .278.097.514.292.708.194.195.43.292.708.292Zm6.996 8.5a2.4 2.4 0 0 1-1.767-.733A2.42 2.42 0 0 1 11 13.496a2.4 2.4 0 0 1 .733-1.767A2.42 2.42 0 0 1 13.504 11a2.4 2.4 0 0 1 1.767.733c.486.49.729 1.08.729 1.771a2.4 2.4 0 0 1-.733 1.767 2.42 2.42 0 0 1-1.771.729Zm.004-1.5a.964.964 0 0 0 .708-.292.964.964 0 0 0 .292-.708.964.964 0 0 0-.292-.708.964.964 0 0 0-.708-.292.964.964 0 0 0-.708.292.964.964 0 0 0-.292.708c0 .278.097.514.292.708.194.195.43.292.708.292ZM5.062 16 4 14.937 14.938 4 16 5.063 5.062 16Z" />
        </svg>
    );
};

export default Percent20;
